import React, { createContext, useContext } from 'react';
import { getFirestore, collection, doc, getDoc, getDocs, query, where, orderBy } from 'firebase/firestore';
import { app } from '../config/firebase';

const FirestoreContext = createContext();

export function useFirestore() {
  return useContext(FirestoreContext);
}

export function FirestoreProvider({ children }) {
  const db = getFirestore(app);

  const getDocuments = async (collectionName, conditions = []) => {
    try {
      let q = collection(db, collectionName);
      
      if (conditions.length > 0) {
        const queryConstraints = conditions.map(([field, operator, value]) => 
          where(field, operator, value)
        );
        q = query(q, ...queryConstraints);
      }
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting documents:', error);
      throw error;
    }
  };

  const getDocument = async (collectionName, docId) => {
    try {
      const docRef = doc(db, collectionName, docId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return {
          id: docSnap.id,
          ...docSnap.data()
        };
      }
      return null;
    } catch (error) {
      console.error('Error getting document:', error);
      throw error;
    }
  };

  const value = {
    db,
    getDocuments,
    getDocument,
    query: (collectionRef, ...queryConstraints) => query(collectionRef, ...queryConstraints),
    where,
    orderBy
  };

  return (
    <FirestoreContext.Provider value={value}>
      {children}
    </FirestoreContext.Provider>
  );
} 